import { ChevronRight } from "lucide-react";
import styles from "./styles.module.scss";
import { LucideIcon } from "lucide-react";
import { clsx } from "clsx";
import { PropsWithChildren } from "react";

export interface CoachingToolsItemBaseProps extends PropsWithChildren {
	icon: LucideIcon;
	onClick: () => void;
	accent?: boolean;
}

export const CoachingToolsItemBase = ({ icon: Icon, onClick, accent, children }: CoachingToolsItemBaseProps) => {
	return (
		<button type="button" className={styles.item} onClick={onClick}>
			<div className={clsx(styles["item__left-icon-container"], { [styles["item__left-icon-container--accent"]]: accent })}>
				<Icon className={styles["item__left-icon"]} />
			</div>
			<div className={styles["item__body"]}>{children}</div>
			<ChevronRight className={styles["item__right-icon"]} />
		</button>
	);
};
